import { createStore } from 'satcheljs';
import '../orchestrators';
import { IAppMetaDataState } from './schema';

export const getMetaDataStore = createStore<IAppMetaDataState>('AppMetaData', {
  raw: {},
  errors: {},
});
